import React from 'react'

import styles from './HelpLink.module.scss'

import { Document as DocumentIcon, NewTab as LinkIcon } from '../../../icons'

export interface IHelpLinkProps {
  link: THelpLink
  className?: string
}

export type THelpLink = {
  url: string
  text: string
}

const HelpLink: React.FC<IHelpLinkProps> = (props) => {
  const { link, className } = props
  return (
    <a
      href={link.url}
      target={'_blank'}
      rel={'noopener noreferrer'}
      className={`
        ${styles.link}
        ${className || ''}
      `}
    >
      <div className={styles.docIconWrapper}>
        <DocumentIcon />
      </div>
      <div className={styles.text}>
        {link.text}
      </div>
      <div className={styles.linkIconWrapper}>
        <LinkIcon />
      </div>
    </a>
  )
}

export default HelpLink
